export default __webpack_public_path__ + "static/media/rt-journey-img-min.22bafadf.png";